import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import OnDemand from "../../assets/img/Featured/app-ondemand-food.png";
import Reserve from "../../assets/img/Featured/app-reserve-park.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import { Header } from "../../components/Header";
const SpecialEventsPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page splash specialEventsPage">
        <div className="background" />
        <Header />
        <div className="page-header">Special Events Venue</div>
        <div className="text-blocks">
          <div className="std-text">
            When it’s time to celebrate a special occasion, help your residents
            and their families reserve the time they prefer and keep the snacks
            and beverages flowing with mobile POS right at their location.
          </div>
        </div>
        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Special Events Venue", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={OnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Special Events Venue", "Reserve");
              addFlow("Reserve");
              navigate("/solutions/reserve");
            }}
          >
            <div className="item-head">
              <LogoMini />
              Reserve
            </div>
            <img src={Reserve} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}

export default SpecialEventsPage;